// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---cache-caches-gatsby-plugin-offline-app-shell-js": () => import("./../../caches/gatsby-plugin-offline/app-shell.js" /* webpackChunkName: "component---cache-caches-gatsby-plugin-offline-app-shell-js" */),
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-archive-js": () => import("./../../../src/pages/archive.js" /* webpackChunkName: "component---src-pages-archive-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-pensieve-index-js": () => import("./../../../src/pages/pensieve/index.js" /* webpackChunkName: "component---src-pages-pensieve-index-js" */),
  "component---src-pages-pensieve-tags-js": () => import("./../../../src/pages/pensieve/tags.js" /* webpackChunkName: "component---src-pages-pensieve-tags-js" */)
}

